class PriceRangeFilter {
  constructor(container) {
    this.container = container;
    this.minInput = container.querySelector('.price-min-input');
    this.maxInput = container.querySelector('.price-max-input');
    this.minSlider = container.querySelector('.price-slider-min');
    this.maxSlider = container.querySelector('.price-slider-max');
    this.applyBtn = container.querySelector('[data-apply-price-filter]');
    this.track = container.querySelector('.price-range-track');
    this.rangeMax = parseInt(container.dataset.rangeMax || 1000);

    this.init();
  }

  init() {
    if (!this.container) return;
    this.setupEventListeners();
    this.updateTrack();
  }

  setupEventListeners() {
    this.minInput?.addEventListener('input', this.handleMinInput.bind(this));
    this.maxInput?.addEventListener('input', this.handleMaxInput.bind(this));
    this.minSlider?.addEventListener('input', this.handleMinSlider.bind(this));
    this.maxSlider?.addEventListener('input', this.handleMaxSlider.bind(this));
    this.applyBtn?.addEventListener('click', this.applyFilter.bind(this));
  }

  handleMinInput(e) {
    const value = Math.min(parseInt(e.target.value) || 0, parseInt(this.maxInput.value) - 1);
    this.minSlider.value = value;
    this.updateTrack();
  }

  handleMaxInput(e) {
    const value = Math.max(parseInt(e.target.value) || 0, parseInt(this.minInput.value) + 1);
    this.maxSlider.value = value;
    this.updateTrack();
  }

  handleMinSlider(e) {
    const value = Math.min(parseInt(e.target.value), parseInt(this.maxSlider.value) - 1);
    this.minInput.value = value;
    this.updateTrack();
  }

  handleMaxSlider(e) {
    const value = Math.max(parseInt(e.target.value), parseInt(this.minSlider.value) + 1);
    this.maxInput.value = value;
    this.updateTrack();
  }

  updateTrack() {
    const minVal = parseInt(this.minSlider.value);
    const maxVal = parseInt(this.maxSlider.value);
    const percent1 = (minVal / this.rangeMax) * 100;
    const percent2 = (maxVal / this.rangeMax) * 100;

    if (this.track) {
      this.track.style.left = percent1 + '%';
      this.track.style.width = (percent2 - percent1) + '%';
    }
  }

  applyFilter() {
    const minVal = this.minInput.value;
    const maxVal = this.maxInput.value;
    const minParam = this.container.dataset.minParam;
    const maxParam = this.container.dataset.maxParam;

    const urlParams = new URLSearchParams(window.location.search);

    if (minVal > 0) urlParams.set(minParam, minVal);
    else urlParams.delete(minParam);

    if (maxVal < this.rangeMax) urlParams.set(maxParam, maxVal);
    else urlParams.delete(maxParam);

    const newUrl = `${window.location.pathname}?${urlParams.toString()}`;
    window.location.href = newUrl;
  }
}

function initAllPriceFilters() {
  document.querySelectorAll('[data-price-range-filter]').forEach(container => {
    new PriceRangeFilter(container);
  });
}

document.addEventListener('DOMContentLoaded', initAllPriceFilters);
document.addEventListener('shopify:section:load', initAllPriceFilters);
document.addEventListener('shopify:filter:ajaxComplete', initAllPriceFilters);
document.addEventListener('facet:updated', initAllPriceFilters);


document.addEventListener('click', (event) => {
  if (event.target.closest('[data-facets-toggle]')) {
    // Wait for drawer to render
    setTimeout(() => {
      initAllPriceFilters();
    }, 500);
  }
});


document.addEventListener('toggle', (event) => {
  if (event.target.matches('details[open]')) {
    initAllPriceFilters();
  }
});

document.addEventListener('DOMContentLoaded', function() {
  const form = document.querySelector('#collection-search-form');
  const input = document.querySelector('#collection-search-input');
  const grid = document.querySelector('.collection .product-grid, .collection-products-wrapper');

  if (!form || !input || !grid) return;

  form.addEventListener('submit', function(e) {
    e.preventDefault();
    const query = input.value.trim();
    if (!query) return;

    const url = `${window.location.pathname}?q=${encodeURIComponent(query)}`;
    fetch(url)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const newGrid = parser.parseFromString(html, 'text/html')
          .querySelector('.collection .product-grid, .collection-products-wrapper');
        if (newGrid) {
          grid.innerHTML = newGrid.innerHTML;
          window.scrollTo({ top: grid.offsetTop - 100, behavior: 'smooth' });
        }
      })
      .catch(console.error);
  });
});

  document.addEventListener('DOMContentLoaded', function() {
  const collectionSearchForms = document.querySelectorAll('.collection-sidebar form[action*="/search"]');
  collectionSearchForms.forEach(form => {
    const searchInput = form.querySelector('input[name="q"]');
    
    if (searchInput) {
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Enter') {
          
          e.preventDefault();
          
          const searchTerm = this.value.trim();
          if (searchTerm) {
         
            window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(searchTerm)}&type=product`;
          }
        }
      });
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {
  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".gs__multi-carousel-upsell-btn");
    if (!btn) return;

    const parent = btn.closest(".gs__upsell-item");
    if (!parent) return;

    const productName = parent.getAttribute("data-child-option-name")?.toLowerCase().trim();
    const map = {
      "personalize his blanket for $10": "_personalize_baby",
      "baby boy balloons from $5": "Boy_Balloon",
      "personalize her blanket for $10": "_personalize_baby",
      "baby girl balloons from $5": "girl_balloon",
      '"a star is born" balloon 9 inch': "boytest",
      '"it\'s a baby girl" pink balloon 9 inch': "girltest",
      "personalize the baby blanket $10": "_personalize_baby",
      "gender neutral balloons from $5": "Neutral_Balloon",
      "big sister gifts from $8": "Big-Sister_addon",
      "big brother gifts from $8": "Big_Brother_G",
      "flowers for mom from $12": "flower_girl",
      "christmas balloons from $5": "christmas-balloons",
      "festive christmas napkins from $4": "christmas-napkin",
      "christmas spa gifts to pamper & relax from $7": "christmas-spa"
    };

    const targetName = map[productName];
    if (!targetName) return;

    
    const targetSection = document.querySelector(`[data-child-name="${targetName}"]`);
    if (targetSection) {
      const checkboxes = targetSection.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
    }

    
    const extraToHide = ['_personalize', '_font', '_color'];
    const allToHide = [...Object.values(map), ...extraToHide];

    allToHide.forEach(name => {
      const section = document.querySelector(`[data-child-name="${name}"]`);
      if (section) section.style.display = "none";
    });

   
    if (targetSection) {
      targetSection.style.display = "block";
    }
  });
});

document.addEventListener("DOMContentLoaded", function() {


  document.addEventListener("click", function(e) {
    
    const personalizeSection = e.target.closest('[data-child-name="_personalize_baby"]');
    if (!personalizeSection) return;

    
    const showSections = ["_personalize", "_font", "_color"];

    showSections.forEach(name => {
      const section = document.querySelector(`[data-child-name="${name}"]`);
      if (section) {
        section.style.display = "block";
      }
    });
  });

});